import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import Primal from './pages/Primal';
import Home from './pages/Home';
import Faq from './pages/Faq';
import PageNotFound from './pages/PageNotFound';
import Header from './components/Header';
import Footer from './components/Footer';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import About from './pages/About';
import Contact from './pages/Contact';

function App() {
  
  useEffect(() => {
    // Initialize Google Analytics with your tracking ID
    ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA
    // Track the current page view
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/primal" element={<Primal />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />

          {/* Catch-all route for non-existent pages */}
          <Route path="*" element={<PageNotFound/>} />

        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
